const SET_TEMPLATE = "SET_TEMPLATE";
export const setTemplate = (template) => ({
  type: SET_TEMPLATE,
  payload: { template },
});

export const templateReducer = (state = [], { type, payload }) => {
  switch (type) {
    case SET_TEMPLATE:
      return payload.template;
    default:
      return state;
  }
};
